import React, { useEffect, useState } from "react";
import ArrowLeft from "../../../assets/arrow-left-long.svg";
//import ArrowLeft from "../../../assets/svgComponents";

interface DateCounterProps {
  initialValue: number;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const DateYearCounter: React.FC<DateCounterProps> = ({
  initialValue,
  onChange,
  disabled,
}) => {
  const [value, setValue] = useState(initialValue);
  const currentYear = new Date().getFullYear();
  const maxYear = 2100;

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const incrementYear = () => {
    if (value < maxYear) {
      const newValue = value + 1;
      setValue(newValue);
      onChange?.(newValue.toString());
    }
  };

  const decrementYear = () => {
    if (value > currentYear) {
      const newValue = value - 1;
      setValue(newValue);
      onChange?.(newValue.toString());
    }
  };

  return (
    <>
      <div className="flex w-full rounded-[8px] border border-[#E2E2E2]">
        <div className="w-[56px] h-[56px] rounded-[8px] ">
          <button
            name="timeline-decrease-button"
            onClick={decrementYear}
            disabled={disabled || value <= currentYear}
            className="bg-white px-[18px] h-full rounded-l-[8px]"
          >
            <img
              src={ArrowLeft}
              className="w-[21px] h-[21px] object-contain"
              alt="Minus sign"
            />
          </button>
        </div>

        <div className="flex-1 flex-col h-[56px] bg-[#F8F8F8] border-x border-[#E2E2E2]">
          <div
            style={{
              boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.07) inset",
            }}
            className="w-full h-full flex items-center justify-center"
          >
            <p>{value}</p>
          </div>
        </div>

        <div className="w-[56px] h-[56px] rounded-[8px]">
          <button
            name="timeline-increase-button"
            onClick={incrementYear}
            className="bg-white px-[18px] h-full rounded-r-[8px]"
            disabled={disabled || value >= maxYear}
          >
            <img
              src={ArrowLeft}
              className="w-[21px] h-[21px] object-contain rotate-180"
              alt="Minus sign"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default DateYearCounter;
